import { getCurrentConnectionInfo } from 'portal-sdk';

import { usePortalConnectionByIndex } from 'src/utils/hooks/usePortalConnectionByIndex';

/**
 * Returns the "current" portal connection for the current url,
 * or the first connection found if we failed to parse url info.
 *
 * Can return null if we failed to get any portal connections.
 */
export const useDefaultPortalConnection = () => {
  const connectionIdx = getCurrentConnectionInfo(window)?.connectionIndex || 0;
  return usePortalConnectionByIndex(connectionIdx).data || null;
};
